import {IoTrashBinOutline} from 'react-icons/io5';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Remove = styled(IoTrashBinOutline)`
  height: 30px;
  width: 30px;
  border-radius: 5px;
  padding: 5px;
  font-size: 18px;
  background-color: transparent;
  cursor: pointer;
  transition: all ease-in-out 0.2s;

  &:hover {
    color: ${(props) => props.theme.colors.red};
    transition: all ease-in-out 0.2s;
    background-color: ${(props) => props.theme.colors.redSoft};
  }
`;
